import { useState } from "react";
import { Col, Container, Form, FormGroup, Input, Label, Row } from "reactstrap";
import { Btn, H4, H6, P } from "../../../../AbstractElements";
import { Href } from "../../../../utils/Constant";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const ForgetPasswordContainer = () => {
  const { t } = useTranslation();
  const [otpSent, setOtpSent] = useState(false);
  const [otpVerified, setOtpVerified] = useState(false);
  const [showPassWord, setShowPassWord] = useState(false);

  const handleSendOtp = () => {
    // Logic for sending OTP to email would go here
    setOtpSent(true);
  };

  const handleVerifyOtp = () => {
    // Logic for verifying OTP would go here
    setOtpVerified(true);
  };

  return (
    <div className="page-wrapper">
      <Container fluid className="p-0">
        <Row>
          <Col xs="12">
            <div className="login-card login-dark">
              <div>
                <div>{/* <CommonLogo /> */}</div>
                <div className="login-main">
                  <Form
                    className="theme-form"
                    onSubmit={(event) => event.preventDefault()}
                  >
                    <H4>{t("ResetYourPassword")}</H4>
                    <FormGroup>
                      <Label className="col-form-label">
                        {t("EnterYourEmail")}
                      </Label>
                      <Row>
                        <Col xs="12">
                          <Input
                            className="mb-1"
                            type="email"
                            placeholder={t("emailPlaceholderOtp")}
                            disabled={otpSent}
                          />
                        </Col>
                        {!otpSent && (
                          <Col xs="12">
                            <div className="text-end">
                              <Btn
                                block
                                color="primary"
                                className="m-t-10"
                                onClick={handleSendOtp}
                              >
                                {t("Send")}
                              </Btn>
                            </div>
                          </Col>
                        )}
                      </Row>
                    </FormGroup>
                    {otpSent && !otpVerified && (
                      <>
                        <div className="mt-4 mb-4">
                          <span className="reset-password-link">
                            {t("didNotReceiveOtp")}
                            <Link className="btn-link text-danger" to={Href}>
                              {t("Resend")}
                            </Link>
                          </span>
                        </div>
                        <FormGroup>
                          <Label className="col-form-label pt-0">
                            {t("EnterOTP")}
                          </Label>
                          <Row>
                            {[...Array(6)].map((_, index) => (
                              <Col key={index}>
                                <Input
                                  className="text-center opt-text"
                                  type="text"
                                  defaultValue=""
                                  maxLength={1}
                                />
                              </Col>
                            ))}
                          </Row>
                        </FormGroup>
                        <FormGroup className="mb-0">
                          <Btn
                            color="primary"
                            block
                            className="w-100"
                            onClick={handleVerifyOtp}
                          >
                            {t("Submit")}
                          </Btn>
                        </FormGroup>
                      </>
                    )}
                    {otpVerified && (
                      <>
                        <H6 className="mt-4">{t("CreateYourPassword")}</H6>
                        <FormGroup>
                          <Label className="col-form-label">
                            {t("NewPassword")}
                          </Label>
                          <div className="form-input position-relative">
                            <Input
                              type={showPassWord ? "text" : "password"}
                              placeholder="*********"
                            />
                            <div className="show-hide">
                              <span
                                onClick={() => setShowPassWord(!showPassWord)}
                                className={!showPassWord ? "show" : ""}
                              />
                            </div>
                          </div>
                        </FormGroup>
                        <FormGroup>
                          <Label className="col-form-label">
                            {t("RetypePassword")}
                          </Label>
                          <Input
                            type={showPassWord ? "text" : "password"}
                            placeholder="*********"
                          />
                        </FormGroup>
                        <FormGroup className="mb-0">
                          <div className="checkbox p-0">
                            <Input id="checkbox1" type="checkbox" />
                            <Label className="text-muted" htmlFor="checkbox1">
                              {t("RememberPassword")}
                            </Label>
                          </div>
                          <Btn color="primary" block className="w-100">
                            {t("Done")}
                          </Btn>
                        </FormGroup>
                      </>
                    )}
                    <P className="mt-4 mb-0 text-center">
                      {t("alreadyHavePassword")}
                      <Link className="ms-2" to={`/authentication/loginsimple`}>
                        {t("SignIn")}
                      </Link>
                    </P>
                  </Form>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ForgetPasswordContainer;
